export const SECTION_NAME = "Job";

export const INTRO_TEXT = `Jobs, available on the Pro Plan of SOS Inventory, provide a convenient way to organize groups of transactions. Each job--and even each stage of a job--can have its own profit-and-loss statement, showing precisely how much money was made or lost on a given set of transactions.`;

export const EXAMPLE_JSON = `{ 
  "id":123,
  "syncToken":0,
  "starred":0,
  "name":"job 1",
  "number":"988",
  "description":"Job for sales order 123",
  "closed":false,
  "archived":false,
  "customer":{ 
    "id":64,
    "name":"Joe Smith"
  },
  "address":{ 
    "line1":"222 Main St",
    "line2":null,
    "line3":null,
    "line4":null,
    "line5":null,
    "city":"Washington",
    "stateProvince":"DC",
    "postalCode":"55555",
    "country":null
  },
  "workcenters":[ 
    { 
      "sequence":10,
      "workcenter":{ 
        "id":2,
        "name":"Procurement"
      }
    },
    { 
      "sequence":20,
      "workcenter":{ 
        "id":7,
        "name":"Inbound"
      }
    },
    { 
      "sequence":30,
      "workcenter":{ 
        "id":8,
        "name":"Measure"
      }
    },
    { 
      "sequence":40,
      "workcenter":{ 
        "id":9,
        "name":"Cut"
      }
    },
    { 
      "sequence":50,
      "workcenter":{ 
        "id":10,
        "name":"Punch"
      }
    },
    { 
      "sequence":60,
      "workcenter":{ 
        "id":1,
        "name":"Finished Goods"
      }
    }
  ],
  "customFields":[ 
    { 
      "id":5,
      "name":"Checkbox",
      "value":"false",
      "dataType":"Boolean"
    }
  ],
}`;

export const ATTRIBUTES = [
  {
    name: "id",
    type: "integer",
    description:
      "Unique identifier for this record. Must not be provided on create transactions.",
  },
  {
    name: "starred",
    type: "integer",
    description: `Indicates if this transaction has been starred. A value of 0 = no star; 1 or 1-3 = starred. Star colors 
      depend on application configuration. This could be one color of star or three colors of stars. See Company Settings in the user guide for more details.`,
  },
  {
    name: "syncToken",
    type: "integer",
    description: `Indicates the current version of this record. If you receive an error when updating a record, it is because your syncToken is for an older version of the record than that which is currently in the database. Please GET the latest version prior to updating.`,
  },
  {
    name: "name",
    type: "string",
    description: `The name for this job.`,
  },
  {
    name: "number",
    type: "string",
    description: `The job number for this record. If you wish to use the automatic numbering capability on the creation of a job, pass the string “auto”.`,
  },
  {
    name: "description",
    type: "string",
    description: `The description for this job.`,
  },
  {
    name: "closed",
    type: "boolean",
    description: `True if the job is closed, false if not.`,
    readOnly: true,
  },
  {
    name: "archived",
    type: "boolean",
    description: `True if item is archived, false if not.`,
    readOnly: true,
  },
  {
    name: "customer",
    type: "reference",
    description: "Customer for this job.",
  },
  {
    name: "address",
    type: "address type",
    description: `The customer’s shipping address for this job.`,
  },
  {
    name: "workcenters",
    type: "array of workcenters",
    description: `The list of work centers for this job.  The sequence indicates the order the job moves through the work centers.
    If creating a job, the Finished Goods work center will always be added as the last work center for you.`,
  },
  {
    name: "customFields",
    type: "array of custom fields",
    description: `The list of custom fields for this object type.`,
  },
];

export const LINE_ITEM = [];

export const QUERY_PARAMS = [
  {
    name: "start",
    type: "number",
    description: `A cursor used in pagination.  This is the row number of the full set of results. 
     The API limits results to a max of 200 results per call.  If you want to retrieve the next set
      of results you can use this parameter to retrive the next set of results.  For example if you
       are retrieving 200 results at a time, you can set start=201 to retrieve the next page of results.`,
  },
  {
    name: "maxresults",
    type: "number",
    description: `The maximum number of results you want to return.  The default is 200, the maximum value allowed.`,
  },
  {
    name: "query",
    type: "string",
    description: `This parameter will filter the results by matches of the string on the following fields: number, description, name, or customer name.`,
  },
  {
    name: "archived",
    type: "string: yes/no",
    description: `A "yes" returns archived records only; a "no" returns only those that have not been archived.`,
  },
  {
    name: "status",
    type: "string: open/closed",
    description: `Filters the result by whether the transaction is open or closed.`,
  },
  {
    name: "createdsince/updatedsince",
    type: "string formatted as YYYY-MM-DDTHH:MM:SS ",
    description: `Filters transactions created or updated since a specified date/time.`,
  },
];

export const SAMPLE_QUERY_REQUEST =
  "/api/v2/job?start=101&maxresults=100&status=open&createdsince=2019-09-10T00:00:00&updatedsince=2019-09-10T23:59:59";
